import axios from "axios";

const baseURL = process.env.REACT_APP_API_URL;


export const axiosInstance = axios.create({
  baseURL,
});

// Request interceptor
axiosInstance.interceptors.request.use(
  (config) => {
    // Example: Add auth token if available
    const token = localStorage.getItem("token");
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Response interceptor
axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => {
    // Example: Handle 401 errors globally
    if (error.response && error.response.status === 401) {
      // Optionally redirect to login or show a message
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);